import { render, staticRenderFns } from "./91.vue?vue&type=template&id=f8297b20&scoped=true&"
var script = {}
import style0 from "./91.vue?vue&type=style&index=0&id=f8297b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8297b20",
  null
  
)

export default component.exports